<template>
    <div class="m-c-list">
        <!--
            if no results:
            show alert, remove results info and pagination (m-c-list__top + m-c-list__bottom)
        -->
        <div v-if="!pagedItems.length && isInit" class="m-c-alert" role="alert">
            <p class="m-c-alert__text">
                {{ $t.message("filterNoResults") }}
            </p>
        </div>

        <div aria-hidden="true" v-if="pagedItems.length" class="m-c-list__top">
            <ListHeader />
        </div>

        <ul class="m-c-list__list">
            <li
                class="m-c-list__item"
                v-for="item in pagedItems"
                :key="item.id"
            >
                <ListItem :projectData="item" />
            </li>
        </ul>

        <div v-if="pagedItems.length" class="m-c-list__bottom">
            <ListResults />
            <ListPagination />
        </div>
    </div>
</template>

<script>
import ListResults from "./ListResults.vue";
import ListPagination from "./ListPagination.vue";
import ListHeader from "./ListHeader.vue";
import ListItem from "./ListItem.vue";
import { mapGetters } from "vuex";

export default {
    name: "List",
    // load components used in template
    components: {
        ListResults,
        ListPagination,
        ListHeader,
        ListItem,
    },
    // computed properties
    computed: {
        ...mapGetters(["pagedItems", "isInit"]),
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
